module.exports = __webpack_public_path__ + "static/media/map_entrance.ebe18470.mp4";